<template>
  <section class="process">
    <h2>换新流程</h2>
    <div class="processBox">
      <div class="processItem">
        <span>旧机评估</span>
      </div>
      <div class="processItem">
        <span>领取奖励金</span>
      </div>
      <div class="processItem">
        <span>回收旧机</span>
      </div>
      <div class="processItem">
        <span>购买新机</span>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {};
  }
};
</script>

<style scoped>
.process {
  width: 3.48rem;
  margin: 0.08rem auto 0rem;
}
.process h2 {
  position: relative;
  font-size: 0.15rem;
  font-weight: bold;
  color: rgba(51, 51, 51, 1);
  padding-left: 0.1rem;
}
.process h2:before {
  display: inline-block;
  content: "";
  position: absolute;
  left: 0;
  top: 0.01rem;
  width: 0.04rem;
  height: 0.16rem;
  background: rgba(255, 201, 92, 1);
  border-radius: 0.02rem;
}
.processBox {
  widows: 3.48rem;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 0px 0.04rem 0px rgba(134, 130, 130, 0.3);
  border-radius: 0.05rem;
  display: flex;
  margin: 0.195rem 0 0 0;
  padding:0.1rem;
}
.processItem {
  display: block;
  width: 0.87rem;
  font-size: 0.16rem;
  text-align: center;
  position: relative;
}
.processItem::before {
  display: inline-block;
  content: "";
  width: 0.29rem;
  height: 0.29rem;
  background: url(../../../assets/image/process_icon.png) 0rem 0rem
  no-repeat;
  background-size: 1.19rem;
}
.processItem:nth-child(2)::before {
  background-position: -0.275rem 0rem;
}
.processItem:nth-child(3)::before {
  background-position: -0.63rem 0rem;
}
.processItem:nth-child(4)::before {
  background-position: -0.93rem 0rem;
}
.processItem::after {
  content: "";
  display: inline-block;
  width: 0.14rem;
  height: 0.005rem;
  background: #fc5b74;
  position: absolute;
  right: -0.08rem;
  top: 0.16rem;
}
.processItem:nth-child(4)::after {
  display: none;
}

.processItem span {
  display: block;
  line-height: 0.125rem;
  font-size: 0.13rem;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  margin-top:0.1rem;
}
</style>
